import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guard/auth.guard';
import { LayoutComponent } from '../layout/layout.component';
import { PrintSubscriptionComponent } from './print-subscription/print-subscription.component';
import { SettingComponent } from './setting/setting.component';

const routes: Routes = [{
  path: 'admin/subscription', component: LayoutComponent,
  canActivate: [AuthGuard],
  children: [
    {path: 'print-subscription', component: PrintSubscriptionComponent},
    {path: 'setting', component: SettingComponent}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionRoutingModule { }
